export const ladderSides = {
    L: {
        label: "Left",
    },
    R: {
        label: "Right",
    },
};
